import React from "react";
import {
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap";
import { Icon } from "../Component";

// const ExportButton = ({ title, options, className, onChange }) => {
//   return (
//     <UncontrolledDropdown direction="down" className={`me-1 ${className}`}>
//       <DropdownToggle
//         outline
//         color="light"
//         className="btn-action bg-white d-none d-sm-inline-flex  fw-normal"
//       >
//         <span>
//           <Icon className={""} name="download"></Icon>
//         </span>
//       </DropdownToggle>
//       <DropdownMenu>
//         <ul className="link-list-opt">
//           {options?.length > 0 &&
//             options?.map((oItem, oIndex) => (
//               <li key={"option" + oIndex}>
//                 <DropdownItem
//                   tag="a"
//                   href="#links"
//                   onClick={(ev) => {
//                     ev.preventDefault();
//                     onChange(oItem?.value);
//                   }}
//                 >
//                   <span>{oItem?.label}</span>
//                 </DropdownItem>
//               </li>
//             ))}
//         </ul>
//       </DropdownMenu>
//     </UncontrolledDropdown>
//   );
// };

const ExportButton = ({ title, options, className, onChange, onClick }) => {
  const hasOptions = Array.isArray(options) && options.length > 0;

  return hasOptions ? (
    <UncontrolledDropdown direction="down" className={`me-1 ${className}`}>
      <DropdownToggle
        outline
        color="light"
        className="btn-action bg-white d-none d-sm-inline-flex fw-normal"
      >
        <span>
          <Icon name="download" />
        </span>
      </DropdownToggle>
      <DropdownMenu>
        <ul className="link-list-opt">
          {options.map((oItem, oIndex) => (
            <li key={"option" + oIndex}>
              <DropdownItem
                tag="a"
                href="#dropdown"
                onClick={(ev) => {
                  ev.preventDefault();
                  onChange && onChange(oItem?.value);
                }}
              >
                <span>{oItem?.label}</span>
              </DropdownItem>
            </li>
          ))}
        </ul>
      </DropdownMenu>
    </UncontrolledDropdown>
  ) : (
    <button
      type="button"
      className={`btn btn-outline-light btn-action bg-white d-none d-sm-inline-flex fw-normal ${className}`}
      onClick={onClick}
    >
      <Icon name="download" className="me-1" />
      <span>{title}</span>
    </button>
  );
};

export default ExportButton;
